module.exports = require("./ta-SG.js");